import React from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";
import { NavigationProp, ParamListBase, useRoute } from "@react-navigation/native";

import * as asyncStorage from "src/util/asyncStorage";
import { kColors } from "src/kColors";

type tReferralLinkParams = {
  params?: { uuid: string };
  key: string;
  name: string;
};

const P105_ReferralLinkChecker: React.FC<{ navigation: NavigationProp<ParamListBase> }> = () => {
  const route = useRoute<tReferralLinkParams>();

  React.useEffect(() => {
    (async () => {
      if (route.params?.uuid) await asyncStorage.setData("referralId", route.params.uuid);
      window.location.href = "/tmt-landing/brands.html";
    })();
  }, [route.params?.uuid]);

  return (
    <View style={[styles.flex1, styles.alignCenter, styles.justifyCenter]}>
      <ActivityIndicator size="large" color={kColors.brandDarkGreen} />
    </View>
  );
};

export const P105 = React.memo(P105_ReferralLinkChecker);

const styles = StyleSheet.create({
  alignCenter: {
    alignItems: "center",
  },
  flex1: {
    flex: 1,
  },
  justifyCenter: {
    justifyContent: "center",
  },
});
